export const BaseUrls = {
    profileUrl: "https://azcv9c2vv2.execute-api.eu-west-1.amazonaws.com/prod/",
    benefitUrl: "https://u4aud5lvy8.execute-api.eu-west-1.amazonaws.com/prod/",
    holidayUrl: "https://t4wn7awbt3.execute-api.eu-west-1.amazonaws.com/prod/",
    registerUrl: "https://uzh0h8isl2.execute-api.eu-west-1.amazonaws.com/uat/registerreq/"
};